import React from "react";

type SvgIconProps = React.ComponentProps<"svg">;
const LUCIDE_ICON_SOURCE = Symbol("lucide-icon-source");

type SvgIconComponent = ((props: SvgIconProps) => React.JSX.Element) & {
  readonly [LUCIDE_ICON_SOURCE]: true;
};

// Use the dashboard icon stroke unless a caller overrides it for a specific glyph.
export const createLucideIcon = (IconComponent: React.ElementType): SvgIconComponent =>
  Object.assign(
    function LucideIcon({ strokeWidth, vectorEffect, ...props }: SvgIconProps) {
      return (
        <IconComponent {...props} vectorEffect={vectorEffect} strokeWidth={strokeWidth ?? 2} />
      );
    },
    { [LUCIDE_ICON_SOURCE]: true as const },
  );

export const isLucideIcon = (IconComponent: React.ElementType): boolean =>
  typeof IconComponent === "function" && LUCIDE_ICON_SOURCE in IconComponent;
